var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreatmentInvestigation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.467,
    height: 12,
    viewBox: "0 0 11.467 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M58.5,182.122l-3.778,4.1c-.392.426-1.361,1.362-.425,2.224s1.693-.074,2.182-.605l3.778-4.1Z",
    transform: "translate(-52.769 -177.911)",
    fill: "#ff2366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M22.139,3.906,17.9,0l-.849.921.566.522-5.6,6.076-.1.1a3.63,3.63,0,0,0-1.249,2.368,1.973,1.973,0,0,0,.706,1.388,2.059,2.059,0,0,0,1.4.621,3.44,3.44,0,0,0,2.278-1.438l5.722-6.211.516.475Zm-7.4,6.116-.125.137c-.479.524-1.134,1.244-1.837,1.244a1.471,1.471,0,0,1-.99-.463,1.385,1.385,0,0,1-.514-.972,3.188,3.188,0,0,1,1.088-1.938l.1-.108c.527-.573,4.567-4.956,5.6-6.076l2.277,2.1Z",
    transform: "translate(-10.672)",
    fill: "#ff2366"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentInvestigation);
export default __webpack_public_path__ + "static/media/treatment_investigation.07e60fd73914f7981e91f27f1fb915dd.svg";
export { ForwardRef as ReactComponent };